import axios from '@/api/config';

const grade = {
  getGradeById(data) {
    return axios.get(`${process.env.BASE_URL}/grade/getGradeById/` + data, {});
  },
  getGradeDetail(data) {
    return axios.get(`${process.env.BASE_URL}/grade/getGradeDetail`, {params: data});
  },
  getGrade(data) {
    return axios.get(`${process.env.BASE_URL}/grade/getGrade`, {params: data});
  },
  getGradeList(data) {
    return axios.get(`${process.env.BASE_URL}/grade/getGradeList`, {params: data});
  },
  getGradeTree(data) {
    return axios.get(`${process.env.BASE_URL}/grade/getGradeTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/grade/pageList`, data);
  },
  addGrade(data) {
    return axios.post(`${process.env.BASE_URL}/grade/addGrade`, data);
  },
  updateGrade(data) {
    return axios.put(`${process.env.BASE_URL}/grade/updateGrade`, data);
  },
  deleteGrade(data) {
    return axios.delete(`${process.env.BASE_URL}/grade/deleteGrade`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/grade/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/grade/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/grade/active`, data);
  },
}

export default grade;



// WEBPACK FOOTER //
// ./src/api/grade.js